// @core/api/endpoints/task/log_time.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LogTimeRequest,
  TimeEntryResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Log time
 * Records time spent working on the task with optional description and billing information. Time entries contribute to task and project reports.
 */
export async function LogTime(
  task_id: string,
  data: LogTimeRequest,
  options?: RequestOptions
): Promise<TimeEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/time`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TimeEntryResponse>(requestPath, data, requestOptions);
}
